import type { AdditionalSelectors } from '@makemydeal/dr-activities-recent-deals';
import { getBffApiUrl } from '@makemydeal/dr-dash-ui-utils';
import * as offerSelectors from '@makemydeal/dr-dash-store/selectors/offerSelectors';
import { dealerSelectors } from '@makemydeal/dr-shared-store';

export const additionalSelectors: AdditionalSelectors = {
    getRecentDealsURL: () => {
        return getBffApiUrl('recent-deals');
    },
    getDealerInfo: (state) => {
        const coOrgId = offerSelectors.getCommonOrgId(state) || '';
        const mmdId = dealerSelectors.getDealerId(state)?.toString() || '';

        return {
            coOrgId,
            mmdId
        };
    }
};
